import { SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { ButtonBoxPropsType } from 'src/ui/components/button/common/types';
import { appearanceStyle, buildBtnDisabledOrLoading, sizeStyles } from 'src/ui/components/button/common/button-utils';
import { withConfig } from 'src/withConfig';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

export const ButtonBox = withConfig(theme => styled('button', { label: 'ButtonBox' }) <ButtonBoxPropsType>`
    ${({ appearance, variant }): SerializedStyles => appearanceStyle(theme, appearance, variant)}
    ${({ size, variant }): SerializedStyles => sizeStyles(theme, size, variant)}
    ${({ disabled, isLoading }): SerializedStyles | null => buildBtnDisabledOrLoading(disabled, isLoading)};
    align-items: center;
    border: 0;
    cursor: pointer;
    display: flex;
    font-weight: ${({variant}) => variant === DefaultComponentVariantType.TERTIARY ? theme.star.fontWeight.xMedium : theme.star.button.common.typography.fontWeightPrimary};
    justify-content: center;
    margin: 0;
    overflow: hidden;
    position: relative;
    ${({ variant }) => variant === DefaultComponentVariantType.TERTIARY ? `border-radius: ${theme.star.radius.small}` : 'border-radius: 0'};
    &::after {
        content: '';
        inset: 0;
        opacity: 0;
        position: absolute;
        transition: opacity .2s ease;
    }
    &:hover,
    &:active {
        &::after {
            opacity: 1;
        }
    }
`);
